import { makeStyles, createStyles } from '@material-ui/core/styles';
import { reskinStyles } from 'core/components/theme/theme-variant';

const brandStyles = {
  forreston: {
    logo: {
      height: 25
    }
  },
  oakwood: {
    logo: {
      height: 32
    }
  },
  // CFM logo is a taller mark (102×48) than the Forreston/Oakwood wordmarks; without an entry it
  // falls to the 48px default and towers over the header. Only height is set (like oakwood); width
  // follows the source's intrinsic aspect ratio (~68px at 32px tall), matching sibling visual
  // weight. Height is a proportional estimate — confirm with design.
  cfm: {
    logo: {
      height: 32
    }
  }
};

export default makeStyles((theme) =>
  createStyles({
    header: {
      height: theme.sizes.headerHeight,
      backgroundColor: theme.colors.header__background_primary,
      justifyContent: 'center',
      display: 'block',
      transition: 'margin-top 200ms ease, visibility 0s',
      ...reskinStyles(theme, {
        borderBottom: `1px solid ${theme.colorPalette.beige_60}`,
        boxShadow: theme.surfaceShadows.header
      })
    },
    // Slid up out of view by a page that wants the height (Staff Quote Revisit on scroll). Once the
    // slide finishes it's also hidden, so its links and search leave the tab order and the
    // accessibility tree.
    headerHidden: ({ hiddenOffset }) => ({
      marginTop: -hiddenOffset,
      boxShadow: 'none',
      visibility: 'hidden',
      transition: 'margin-top 200ms ease, visibility 0s linear 200ms'
    }),
    // Let the header grow to fit the taller self-contained lockup instead of clamping to headerHeight.
    headerFlexible: {
      height: 'auto',
      minHeight: theme.sizes.headerHeight
    },
    logoLockup: {
      display: 'flex',
      alignItems: 'center'
    },
    logo: ({ brandName }) => ({
      height: 48,
      marginLeft: 15,
      display: 'block',
      ...(brandStyles[brandName]?.logo || {})
    }),
    partnerLogoContainer: {
      display: 'flex',
      alignItems: 'center',
      marginLeft: theme.spacing(4),
      paddingLeft: theme.spacing(4),
      borderLeft: `1px solid ${theme.colorPalette.beige_75}`
    },
    partnerLogo: {
      height: 36,
      maxWidth: 180,
      objectFit: 'contain'
    },
    // Self-contained lockup stands in for the Branch logo (no divider), sized up via the flexible header.
    partnerLogoSelfContained: {
      height: 120,
      maxWidth: 560,
      marginLeft: 15,
      objectFit: 'contain',
      display: 'block'
    },
    toolbar: {
      display: 'flex',
      justifyContent: 'space-between',
      height: theme.sizes.headerHeight
    },
    toolbarFlexible: {
      height: 'auto',
      minHeight: theme.sizes.headerHeight,
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3)
    },
    searchContainer: {
      width: '100%'
    },
    // Condensed layout: the search fills the bar between the logo and the account menu.
    condensedSearch: {
      flex: '1 1 auto',
      minWidth: 0,
      margin: theme.spacing(0, 6)
    },
    menuButton: {
      flex: 'none',
      color: theme.colors.text_primary,
      [`@media (min-width: ${theme.screens.tablet}px)`]: { display: 'none' }
    }
  })
);
